export const RESULT = [
  {id: 1, name: "Đạt"},
  {id: 2, name: "Không đạt"},
];

export const EVALUATE_STATUS = {
  NOT_RATE_YET: {
    code: 1,
    name: "Chưa đánh giá",
  },
  EVALUETING: {
    code: 2,
    name: "Đang đánh giá",
  },
  EVALUATED: {
    code: 3,
    name: "Đã đánh giá",
  },
};

export const REMEDIATION_PLAN_STATUS = {
  COMPLETED: 3,
}
